import { useEffect, useState } from "react";
import { getApi } from "../../../../services/api/globalApi";
import DateInput from "../../../../components/common/inputs/DateInput";
import Title from "../../../../components/common/title/Title";
import { digitsThree } from "../../../../utils/price";

export default function TotalCommision() {
  const [reportsData, setReportsData] = useState(null);

  const getOrdersReports = async (params) => {
    const path = "/admin/reports/wallets/totalCommisions";
    try {
      const response = await getApi({ path, params: { ...params } });
      setReportsData(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOrdersReports({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getOrdersReports(allFilter);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 mt-6">
      <Title title={"کمیسیون های پرداختی"} />
      <div className="w-full flex flex-col sm:flex-row items-center sm:items-start flex-wrap my-8 gap-6 px-6">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, from: e })}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, to: e })}
        />
      </div>{" "}
      <div className="w-full flex-wrap flex justify-center items-cneter gap-4">
        <div className="px-14 py-6 rounded-xl text-white bg-blue-600 flex items-center justify-center flex-col gap-4">
          <p>مبلغ</p>
          <span> {digitsThree(reportsData?.amount)}</span>
        </div>
      </div>
    </div>
  );
}
